module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.3e1f7a5.eot";